// "Report this entry" rules. Shared by the report dialog (browser) and the API (functions/api/report),
// so the reasons and the limits can never drift apart.

export const REPORT_REASONS = [
  { id: "location", label: "The location looks wrong" },
  { id: "details", label: "Wrong or misleading details (name, date, facts)" },
  { id: "duplicate", label: "Duplicate of another wreck on the map" },
  { id: "scope", label: "Not a shipwreck, or out of scope for this map" },
  { id: "photo", label: "A photo is misused, uncredited or shouldn't be here" },
  { id: "inappropriate", label: "Spam or inappropriate content" },
  { id: "other", label: "Something else (explain below)" },
];

export const REPORT_REASON_LABELS = Object.fromEntries(REPORT_REASONS.map((r) => [r.id, r.label]));

// Own keys only: `"toString" in obj` is true for every object, so it would accept inherited names as valid codes.
const has = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

export const MAX_REPORT_NOTE = 500;
export const MAX_OPEN_REPORTS_PER_USER = 10;

// What an admin can do with a report.
export const REPORT_ACTIONS = {
  resolve: { status: "resolved", label: "Resolved", message: "Thanks for the report. We looked into it and took action." },
  dismiss: { status: "dismissed", label: "Dismissed", message: "Thanks for the report. We looked into it and no change was needed." },
};
export const MAX_RESOLUTION_NOTE = 300;

// Validates a report request body. Returns { reason, note } or { error }.
export function parseReport(body) {
  const reason = typeof body?.reason === "string" ? body.reason : "";
  const note = typeof body?.note === "string" ? body.note.trim().slice(0, MAX_REPORT_NOTE) : "";
  if (!reason) return { error: "Please choose a reason for your report" };
  if (!has(REPORT_REASON_LABELS, reason)) return { error: "Unknown report reason" };
  if (reason === "other" && !note) return { error: "Please explain what's wrong" };
  return { reason, note };
}

// Validates an admin's decision on a report. Returns { action, status, note } or { error }.
export function parseResolution(body) {
  const action = typeof body?.action === "string" ? body.action : "";
  if (!has(REPORT_ACTIONS, action)) return { error: "Choose resolve or dismiss" };
  const note = typeof body?.note === "string" ? body.note.trim().slice(0, MAX_RESOLUTION_NOTE) : "";
  return { action, status: REPORT_ACTIONS[action].status, note };
}
